import { css } from "@linaria/core";
import { makeSelectors } from "../css/maker.selectors";

export const wrapper = css`
  background-color: transparent;
  display: block;
  transition: background-color 0.1s linear;

  /**
   * here is my overflowing comment with a lot of text that hopefully overflows
   */
  &.withPlaceholder {
    background-color: rgb(0 0 0 / 0.15);
  }
`;

export const image = css`
  opacity: 0;

  &.withTransition {
    transition: opacity 0.15s linear;
  }

  &.loaded {
    opacity: 1;
  }
`;

export const postloadedImageSelectors = makeSelectors({
  image,
  wrapper,
});
